import { render } from "./oap-beauty-profile.vue?vue&type=template&id=b76bd5aa"
import script from "./oap-beauty-profile.vue?vue&type=script&lang=js"
export * from "./oap-beauty-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__